import api from "./api";

// Create a new category with full classification and availability options
const createCategory = async (categoryData) => {
  const response = await api.post("/admin-category", categoryData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// Get all categories with advanced filtering
const getAllCategories = async (filters = {}) => {
  const response = await api.get("/admin-category", { params: filters });
  return response.data;
};

// Get category by ID with additional details
const getCategoryById = async (categoryId, options = {}) => {
  const response = await api.get(`/admin-category/${categoryId}`, {
    params: options,
  });
  return response.data;
};

// Update category by ID
const updateCategoryById = async (categoryId, categoryData) => {
  const response = await api.put(
    `/admin-category/${categoryId}`,
    categoryData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

// Delete category by ID with optional reassignment
const deleteCategoryById = async (categoryId, reassignTo = null) => {
  const response = await api.delete(`/admin-category/${categoryId}`, {
    data: { reassignTo },
  });
  return response.data;
};

// Update category order
const updateCategoryOrder = async (categories) => {
  const response = await api.put("/admin-category/order", { categories });
  return response.data;
};

// Sync category statistics
const syncCategoryStats = async (categoryId = null) => {
  const url = categoryId
    ? `/admin-category/${categoryId}/sync-stats`
    : "/admin-category/sync-stats";
  const response = await api.post(url);
  return response.data;
};

// Get categories for dropdown
const getCategoriesForDropdown = async (currentCategoryId = null) => {
  const params = {
    forDropdown: true,
    ...(currentCategoryId && { currentCategoryId }),
  };
  const response = await api.get("/admin-category", { params });
  return response.data;
};

// Get category tree structure
const getCategoryTree = async (filters = {}) => {
  const response = await api.get("/admin-category", {
    params: { ...filters, tree: true },
  });
  return response.data;
};

// Get categories by branch
const getCategoriesByBranch = async (branchCode, storeCode = null) => {
  const params = {
    branchCode,
    ...(storeCode && { storeCode }),
    includeStats: true,
  };
  const response = await api.get("/admin-category", { params });
  return response.data;
};

// ========== NEW PRICING METHODS ==========

// Set pricing rule for a specific branch
const setCategoryPricingForBranch = async (categoryId, data) => {
  const response = await api.post(
    `/admin-category/${categoryId}/pricing-rules/branch`,
    data
  );
  return response.data;
};

// Remove pricing rule for a specific branch
const removeCategoryPricingForBranch = async (
  categoryId,
  branchCode,
  data = {}
) => {
  const response = await api.delete(
    `/admin-category/${categoryId}/pricing-rules/branch/${branchCode}`,
    { data }
  );
  return response.data;
};

// Get all pricing rules for a category
const getCategoryPricingRules = async (categoryId) => {
  const response = await api.get(`/admin-category/${categoryId}/pricing-rules`);
  return response.data;
};

// Get complete pricing info for a specific branch
const getCategoryPricingInfo = async (categoryId, branchCode) => {
  const response = await api.get(
    `/admin-category/${categoryId}/pricing-info/${branchCode}`
  );
  return response.data;
};

// Bulk update products with category pricing rule
const bulkUpdateProductsPricing = async (categoryId, data) => {
  const response = await api.post(
    `/admin-category/${categoryId}/bulk-update-products`,
    data
  );
  return response.data;
};

// Get category pricing audit logs
const getCategoryPricingAudit = async (categoryId, params = {}) => {
  const response = await api.get(
    `/admin-category/pricing-audit/${categoryId}`,
    {
      params,
    }
  );
  return response.data;
};

// Get all pricing audit logs
const getAllPricingAudits = async (params = {}) => {
  const response = await api.get("/admin-category/pricing-audit", { params });
  return response.data;
};

const categoryService = {
  createCategory,
  getAllCategories,
  getCategoryById,
  updateCategoryById,
  deleteCategoryById,
  updateCategoryOrder,
  syncCategoryStats,
  getCategoriesForDropdown,
  getCategoryTree,
  getCategoriesByBranch,
  // Pricing methods
  setCategoryPricingForBranch,
  removeCategoryPricingForBranch,
  getCategoryPricingRules,
  getCategoryPricingInfo,
  bulkUpdateProductsPricing,
  getCategoryPricingAudit,
  getAllPricingAudits,
};

export default categoryService;
